import React, { Component } from "react";
import { injectIntl, IntlShape } from "@ai360/core/intl";

import { messages } from "~/admin/agBytes/i18n-messages";
import { DataTable } from "~/core";
import { withCrud } from "~/hocs";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";

import { service, actions } from "./log-data";

interface IEquationParameterLogProps {
    records?: Record<string, unknown>[];
    intl: IntlShape;
}

export class EquationParameterLog_ extends Component<IEquationParameterLogProps> {
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render(): JSX.Element {
        return (
            <div>
                <DataTable
                    service={service}
                    isCheckbox={false}
                    showFilterInput={false}
                    messages={messages}
                    {...this.props}
                    records={this.getFormattedRecords(this.props.records)}
                />
            </div>
        );
    }
}
export const EquationParameterLog = injectIntl(withCrud(EquationParameterLog_, service, actions));
